export const employeeShortLinks = {
  google: 'https://bit.ly/g-reaction',
  apple: 'https://apple.co/2WrmdNI',
}
export const coachShortLinks = {
  google: 'http://bit.ly/Rc-Coach',
  apple: 'https://apple.co/2uC44j3',
}
